import { BehaviorSubject } from 'rxjs'
import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { router } from '@/router'
import { IS_PRIVATE } from '@/common/const/env'

export enum AuthState {
  /** 未授权 */
  notAuth = 0,
  /** 已授权 */
  authed = 1,
  /** 授权过期 */
  authExpired = 2
}

export interface AuthInfo {
  /** 申请码 */
  apply_code: string
  /** 授权状态, 0-未授权,1-已授权,2-授权过期 */
  authorize_state: number
  /** Windows终端数 */
  windows_num: number
  /** server终端数 */
  server_num: number
  /** Linux终端数 */
  linux_num: number
  /** 授权开始时间 */
  authorize_start_time: number
  /** 授权结束时间 */
  authorize_end_time: number
  /** 授权服务列表 */
  authorize_services: string[]
  /** 上次更新时间 */
  last_updated_time: number
  /** 服务器时间 */
  server_time: number
  /** 服务器ip */
  deploy_ip: string
}

let DEFAULT_AUTH = {} as AuthInfo

@Injectable()
export class SystemAuthService {
  authInfo = DEFAULT_AUTH
  updateAuthInfoEvent = new BehaviorSubject<AuthInfo>(this.authInfo)

  constructor (private http: Http) {
    this.updateRemoteAuthInfo()
  }

  /** 从接口更新授权信息 */
  updateAuthInfo (info: AuthInfo) {
    delete (info as any).resp_common
    this.authInfo = info
    this.updateAuthInfoEvent.next(info)
  }

  /** 从接口更新授权信息 */
  updateRemoteAuthInfo () {
    if (!IS_PRIVATE) {
      return Promise.resolve(true)
    }

    return this.getAuthInfo().then((res) => {
      this.updateAuthInfo(res)
      if (res.authorize_state === AuthState.notAuth) {
        router.replace('/authorize')
      }
    })
  }

  getAuthInfo () {
    return this.http.post<AuthInfo>('/privatization/authorization/get', {})
  }
}
